import { CreateRounded } from '@mui/icons-material'
import classNames from 'classnames'
import { TProduct } from 'feature/appeals/type'
import { TSuggest } from 'feature/registration/types'
import { MarkIconType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { useEffect } from 'react'
import { useActions } from 'store/hooks'
import { IconButton } from 'ui'

import { TModalsType } from '../OrderInformationBlock'

import style from './OrderLocation.module.scss'
import styleInformation from 'widget/InformationBlock/InformationBlock.module.scss'

type TOrderLocation = {
  isEdit: boolean
  isEditAddressModalOpen: boolean
  openModal: (type: TModalsType, product?: TProduct) => void
  location: TSuggest
}
export const OrderLocation = ({
  isEdit,
  isEditAddressModalOpen,
  openModal,
  location,
}: TOrderLocation) => {
  const { setStaticMarkCoords, setStaticMarkIcon, setCenter } = useActions()

  useEffect(() => {
    if (!location || !location.geoLat || !location.geoLon) return

    setStaticMarkCoords([Number(location.geoLat), Number(location.geoLon)])
    setStaticMarkIcon(MarkIconType.building)
    setCenter([Number(location.geoLat), Number(location.geoLon)])
  }, [location])

  return (
    <div className={styleInformation.informationBlock}>
      <div className={classNames(styleInformation.title, style.title)}>
        <span className='h4'>Адрес объекта</span>

        {isEdit && (
          <IconButton
            className='buttonWithoutEffects'
            onClick={() => openModal('address')}
            data-testid='order-location-edit'
          >
            <CreateRounded />
          </IconButton>
        )}
      </div>

      <div className={style.informationBlockContent}>
        <span className={classNames('default-text', style.addressText)}>
          {location.address}
        </span>
        <div className={style.mapWrapper}>
          {!isEditAddressModalOpen && (
            <YandexMap
              isMapClickable={false}
              hideControls={true}
              marks={[MarkType.staticMark]}
              controls={null}
              className={style.map}
            />
          )}
        </div>
      </div>
    </div>
  )
}
